import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CustomStoryCard2 from "../../molecules/CustomStoryCard2";
import { getSlug, getCollectionName } from "../../utils/utils";

import "./fourStories.m.css";

const FourStories = ({ collection, sections, domainSlug }) => {
  const [firstImageWidth, setFirstImageWidth] = useState([]);

  useEffect(() => {
    global.deviceWidth < 876 ? setFirstImageWidth([400]) : setFirstImageWidth([620]);
  }, []);

  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const stories = collection.items
    .filter((item) => item.type === "story")
    .slice(0, 4)
    .map((item) => item.story);

  return (
    <div styleName="wrapper" className="four-stories" data-testid="4-story-component">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collectionName}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}

      <div styleName="stories">
        <div styleName="first-story">
          {stories.splice(0, 1).map((story, index) => (
            <CustomStoryCard2
              headlineType={35}
              subHeadlineType={36}
              story={story}
              key={index}
              className="story-card"
              aspectRatio={[16, 9]}
              imageType="image16x9"
              isSection={false}
              isImageCaptionRequired={false}
              widths={firstImageWidth}
              isExcerpt={true}
              updatedFont={true}
              src="four-stories"
              updateSubHeadline={true}
            />
          ))}
        </div>

        <Organism1 stories={stories.splice(0, 3)} />
      </div>
    </div>
  );
};

FourStories.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

FourStories.storyLimit = 4;

export default connect(mapStateToProps, null)(FourStories);
